"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
function Span(_a) {
    var _b, _c;
    var children = _a.children, _d = _a.size, size = _d === void 0 ? "base" : _d, _e = _a.appearance, appearance = _e === void 0 ? "default" : _e, _f = _a.background, background = _f === void 0 ? false : _f, _g = _a.bold, bold = _g === void 0 ? false : _g, _h = _a.trimText, trimText = _h === void 0 ? false : _h, trimLines = _a.trimLines;
    var className = (0, classnames_1.default)("nimbus--text", "nimbus--text-span", "nimbus--text-size--".concat(size), "nimbus--text-color--".concat(appearance), (_b = {}, _b["nimbus--text-background--".concat(appearance)] = background, _b), { "nimbus--text--bold": bold }, { "nimbus--text--trim": trimText }, (_c = {}, _c["nimbus--text--trim-".concat(trimLines)] = trimText, _c));
    return React.createElement("span", { className: className }, children);
}
exports.default = Span;
//# sourceMappingURL=Text.Span.js.map